import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { FETCH_BUY_NOW_OFFERS, FETCH_OFFERS } from '../../redux/Offers';
import {
  FETCH_NEW_BETS,
  FETCH_MY_BETS
} from '../../redux/BetsTables';
import {
  FETCH_ARCHIVE_ACCEPTED,
  FETCH_ARCHIVE_SOLD,
} from '../../redux/ArchiveTables';
import {
  BROWSE,
  BUY_NOW,
  IN_REALIZATION,
  MY_BETS,
  NEW_BETS,
  ACCEPTED,
  SOLD,
  navigationMapping,
  ADS,
} from '../../consts/navigation';
import { FETCH_IN_REALIZATION } from '../../redux/InRealization';
import { FETCH_INVOICES } from '../../redux/Invoices';
import BreadcrumbsDefault from './BreadcrumbsDefault/BreadcrumbsDefault';
import BreadcrumbsSettings from './BreadcrumbsSettings/BreadcrumbsSettings';
import BreadcrumbsOfferDetails from './BreadcrumbsOfferDetails/BreadcrumbsOfferDetails';
import BreadcrumbsBets from './BreadcrumbsBets/BreadcrumbsBets';
import BreadcrumbsArchive from './BreadcrumbsArchive/BreadcrumbsArchive';
import BreadcrumbsConversations from './BreadcrumbsConversations/BreadcrumbsConversations';
import BreadcrumbsContent from './BreadcrumbsContent/BreadcrumbsContent';
import './BreadcrumbsContainer.scss';
import BreadcrumbsOffer from './BreadcrumbsOffer/BreadcrumbsOffer';
import BreadcrumbsAds from './BreadcrumbsAds/BreadcrumbsAds';
import { FETCH_ADS } from '../../redux/Ads';


class BreadcrumbsContainer extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      this.props.pathname !== nextProps.pathname ||
      this.props.detailsModel !== nextProps.detailsModel ||
      this.props.detailsYear !== nextProps.detailsYear ||
      this.props.newOffersCount !== nextProps.newOffersCount ||
      this.props.recentNewBets !== nextProps.recentNewBets
    );
  }
  searchBrowse = () => {
    this.props.fetchOffers();
  }
  searchBuyNow = () => {
    this.props.fetchBuyNowOffers();
  }

  searchInRealization = () => {
    this.props.fetchInRealization();
  }

  searchInvoices = () => {
    this.props.fetchInvoices();
  }

  searchBets = (query) => {
    const { pathname, fetchNewBets, fetchMyBets } = this.props;
    switch (pathname) {
      case navigationMapping[NEW_BETS].table_url:
        return fetchNewBets({ query });
      case navigationMapping[MY_BETS].table_url:
        return fetchMyBets({ query });
      default:
        return fetchMyBets({ query });
    }
  }
  searchArchive = (query) => {
    const {
      pathname,
      fetchArchiveAccepted,
      fetchArchiveSold,
    } = this.props;
    switch (pathname) {
      case navigationMapping[SOLD].table_url:
        return fetchArchiveSold({ query });
      default:
        return fetchArchiveAccepted({ query });
    }
  }


  renderContent = (pathname) => {
    const { recentNewBets, hashId } = this.props;
    const browseOfferDetails = navigationMapping[BROWSE].details_url;
    const betsOfferDetails = navigationMapping[MY_BETS].details_url;
    const adsTable = navigationMapping[ADS].table_url;
    const realizationOfferDetails = navigationMapping[IN_REALIZATION].details_url;
    const archiveOfferDetails = navigationMapping[ACCEPTED].details_url;
    const singleOfferRedirect = '/dashboard/offers'
    const isInPathname = url => pathname.includes(url);
    if (
      isInPathname(browseOfferDetails)
      || isInPathname(betsOfferDetails)
      || isInPathname(realizationOfferDetails)
      || isInPathname(archiveOfferDetails)
      || isInPathname(singleOfferRedirect)
    ) {
      const { detailsModel, detailsName, detailsYear, whichFolder } = this.props;
      const name = get(detailsName, 'name');
      return (
        <BreadcrumbsOfferDetails
          model={detailsModel}
          name={name}
          year={detailsYear}
          hashId={hashId}
          whichFolder={whichFolder}
        />
      );
    }
    if (isInPathname(adsTable)) {
      return (
        <BreadcrumbsAds
          onSearchClick={this.props.fetchAds}
          tableName="ads"
          pathname={pathname}
        />
      );
    }
    const pages = {
      '/dashboard/settings/general': <BreadcrumbsSettings />,
      '/dashboard/settings/manage': <BreadcrumbsSettings />,
      [navigationMapping[BROWSE].table_url]: <BreadcrumbsOffer onSearchClick={this.searchBrowse} tableName={BROWSE} />,
      [navigationMapping[BUY_NOW].table_url]: <BreadcrumbsOffer onSearchClick={this.searchBuyNow} tableName={BUY_NOW} />,
      [navigationMapping[NEW_BETS].table_url]: <BreadcrumbsBets recentNewBets={recentNewBets} onSearchClick={this.searchBets} tableName={NEW_BETS} />,
      [navigationMapping[MY_BETS].table_url]: <BreadcrumbsBets recentNewBets={recentNewBets} onSearchClick={this.searchBets} tableName={MY_BETS} />,
      [navigationMapping[ACCEPTED].table_url]: <BreadcrumbsArchive
        onSearchClick={this.searchArchive}
        tableName={ACCEPTED}
      />,
      [navigationMapping[SOLD].table_url]: <BreadcrumbsArchive
        onSearchClick={this.searchArchive}
        tableName={SOLD}
      />,
      '/dashboard/conversations': <BreadcrumbsConversations />,
      [navigationMapping[IN_REALIZATION].table_url]: <BreadcrumbsDefault onSearchClick={this.searchInRealization} tableName={IN_REALIZATION} />,
      '/dashboard/invoices': <BreadcrumbsDefault onSearchClick={this.searchInvoices} tableName="invoices" />,
      '/dashboard/content': <BreadcrumbsContent />,
    };
    return pages[pathname];
  };
  render() {
    const { pathname } = this.props;
    return (
      <div className="col-md-10 right-column main-area">
        {this.renderContent(
          pathname,
        )}
      </div>
    );
  }
}

BreadcrumbsContainer.propTypes = {
  pathname: PropTypes.string.isRequired,
  fetchOffers: PropTypes.func.isRequired,
  fetchBuyNowOffers: PropTypes.func.isRequired,
  fetchNewBets: PropTypes.func.isRequired,
  fetchMyBets: PropTypes.func.isRequired,
  fetchInRealization: PropTypes.func.isRequired,
  fetchArchiveAccepted: PropTypes.func.isRequired,
  fetchArchiveSold: PropTypes.func.isRequired,
  fetchAds: PropTypes.func.isRequired,
  fetchInvoices: PropTypes.func.isRequired,
  whichFolder: PropTypes.string,
  detailsModel: PropTypes.string,
  detailsYear: PropTypes.string,
  recentNewBets: PropTypes.bool,
  hashId: PropTypes.string,
};

BreadcrumbsContainer.defaultProps = {
  detailsModel: '',
  detailsName: [],
  detailsYear: null,
  recentNewBets: false,
  whichFolder: null,
  hashId: null,
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchOffers: query => dispatch(FETCH_OFFERS(query)),
    fetchBuyNowOffers: query => dispatch(FETCH_BUY_NOW_OFFERS(query)),
    fetchNewBets: query => dispatch(FETCH_NEW_BETS(query)),
    fetchMyBets: query => dispatch(FETCH_MY_BETS(query)),
    fetchInRealization: query => dispatch(FETCH_IN_REALIZATION(query)),
    fetchArchiveAccepted: query => dispatch(FETCH_ARCHIVE_ACCEPTED(query)),
    fetchArchiveSold: query => dispatch(FETCH_ARCHIVE_SOLD(query)),
    fetchInvoices: query => dispatch(FETCH_INVOICES(query)),
    fetchAds: query => dispatch(FETCH_ADS(query)),
  };
};

const mapStateToProps = (state) => {
  return {
    detailsModel: get(state, ['offerDetails', 'data', 'model']),
    detailsName: get(state, ['offerDetails', 'data', 'brand']),
    detailsYear: get(state, ['offerDetails', 'data', 'year']),
    hashId: get(state, ['offerDetails', 'data', 'hash_id']),
    newOffersCount: get(state, ['offers', 'new_offers_count']),
    newInRealizationCount: get(state, ['inRealization', 'new_offers_count']),
    recentNewBets: get(state, ['bets', 'recentNewBets']),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BreadcrumbsContainer);
